import { Grid, Typography } from '@material-ui/core';
import { Icon, UploadOutlineIcon } from '@fountain/ripple/icon';
import React from 'react';

import useStyles from './styles';

const MobileCustomDropzoneUploadInput = () => {
  const classes = useStyles();

  return (
    <Grid className={classes.container}>
      <Icon icon={UploadOutlineIcon} size="xs" />
      <Typography className={classes.browseAFile}>Browse a File</Typography>
    </Grid>
  );
};
export default MobileCustomDropzoneUploadInput;
